<template>
    <div>
        <media-chooser
            :value="images"
            type="image"
            multiple
            @input="onImagesChange"
        />
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            images: []
        };
    },

    mounted() {
        this.images = [...this.value];
    },

    methods: {
        onImagesChange(images) {
            this.images = images.length ? images : [];

            this.$emit('input', this.images);
        }
    }
};
</script>
